// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuel-grades.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuel-grades/fuel-grades.js';

mount([g0]);
